<template>
  <span class="text-nowrap">
    <span class="text-secondary goal-event-time text-small">{{
      localizedDateString(event.createdAt)
    }}</span>
    <span @mouseleave="resetCopyLabel">
      <i :class="copyIcon" class="pointer ml-2" :id="'link-' + uuid" @click="copyLink"></i>
    </span>
    <tooltip placement="top" :target="'link-' + uuid">{{ copyLabel }}</tooltip>
  </span>
</template>

<script>
import { ENTITY_TYPE } from '@/constants/entities'
import { localizedDateTimeString } from '@/datetime'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import TeamMixin from '@/mixins/TeamMixin'
import copyToClipboard from '@/utils/copyToClipboard'
import Tooltip from '@/components/Tooltip'
import getURLFromRouteLocation from '@/utils/getURLFromRouteLocation'
import {
  getGoalPageRouteConfig,
  getInitiativePageRouteConfig,
  getKrPageRouteConfig
} from '@/utils/navigationConfigs'

const copyLabel = {
  copy: 'Click to copy link',
  copied: 'Copied!'
}
const copyIcon = {
  copy: 'link-icon',
  copied: 'green-checkmark-icon'
}

/**
 * This component shows the time of the event for goal/kr/initiative. It also gives capability to create permalink for event
 */
export default {
  name: 'EventTime',
  props: ['event', 'context'],
  mixins: [TeamMixin, ComponentIdMixin],
  data() {
    return {
      copyLabel: copyLabel.copy,
      copyIcon: copyIcon.copy
    }
  },
  components: {
    Tooltip
  },
  methods: {
    getEventLocation(event) {
      if (this.context === ENTITY_TYPE.KEY_RESULT) {
        return getKrPageRouteConfig({
          krId: event.keyResultId,
          orgId: event.organizationId,
          query: {
            event: this.event.id
          }
        })
      } else if (this.context === ENTITY_TYPE.GOAL) {
        return getGoalPageRouteConfig({
          goalId: event.goalId,
          orgId: event.organizationId,
          query: {
            event: this.event.id
          }
        })
      } else if (this.context === ENTITY_TYPE.INITIATIVE) {
        return getInitiativePageRouteConfig({
          initiativeId: this.event.initiativeId,
          orgId: this.event.organizationId,
          query: {
            event: this.event.id
          }
        })
      }
    },
    resetCopyLabel() {
      setTimeout(() => {
        this.copyLabel = copyLabel.copy
        this.copyIcon = copyIcon.copy
      }, 500)
    },
    copyLink() {
      const location = this.getEventLocation(this.event)
      const pageUrl = getURLFromRouteLocation(location)
      copyToClipboard(pageUrl)
      this.copyLabel = copyLabel.copied
      this.copyIcon = copyIcon.copied
    },
    localizedDateString(date) {
      if (typeof date === 'string') {
        date = new Date(Date.parse(date))
      }
      return localizedDateTimeString(date)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.link-icon,
.green-checkmark-icon {
  @include dimension(13px, 13px);
}
</style>
